exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (max-width: 600px) {\nthead[data-v-04b73e75] {\n        top: 88px !important;\n}\n}\n", ""]);

// exports
